import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { hasSessionReviews } from '@src/components/sco/Advisors/reviews/sessionReviewHelpers';
import { OWN_SESSION_REVIEW_SUMMARY } from '@src/gql/queries/SessionReviews';
import type { Query } from '@src/graphql-types';

/** Clarity `LinkedAccount.app` (startups3 `CLARITY_LINKED_APP`). */
export const CLARITY_LINKED_ACCOUNT_APP = 'clarity';

/** Viewer's own review summary + whether a Clarity account is linked (drives the Reviews tab). */
export const useOwnSessionReviewSummary = t0 => {
  const $ = _c(16);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    skip: t2
  } = t1;
  const skip = t2 === undefined ? false : t2;
  let t3;
  if ($[2] !== skip) {
    t3 = {
      skip
    };
    $[2] = skip;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const query = useQuery(OWN_SESSION_REVIEW_SUMMARY, t3);
  const user = query.data?.currentUser;
  const summary = user?.sessionReviewSummary ?? null;
  let t4;
  if ($[4] !== user?.linkedAccounts) {
    t4 = user?.linkedAccounts ?? [];
    $[4] = user?.linkedAccounts;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = t4.some(_temp);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const hasLinkedClarity = t5;
  let t6;
  if ($[8] !== summary) {
    t6 = hasSessionReviews(summary);
    $[8] = summary;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = query.loading && !query.data;
  let t8;
  if ($[10] !== hasLinkedClarity || $[11] !== query.refetch || $[12] !== summary || $[13] !== t6 || $[14] !== t7) {
    t8 = {
      summary,
      hasReviews: t6,
      hasLinkedClarity,
      loading: t7,
      refetch: query.refetch
    };
    $[10] = hasLinkedClarity;
    $[11] = query.refetch;
    $[12] = summary;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(account) {
  return account?.app === CLARITY_LINKED_ACCOUNT_APP;
}